import React from "react";
import PropTypes from "prop-types";

import { TextField, FormControlLabel, Checkbox } from "@mui/material";

const Eupago = ({ externalKey, chargesEnabled, onChange }) => {
  if (chargesEnabled) {
    return (
      <FormControlLabel
          control={
            <Checkbox
              checked={true}
              disabled
              sx={{
                '&.Mui-disabled': {
                  '&.Mui-checked': {
                    '& .MuiSvgIcon-root': {
                      color: 'success.main',
                    }
                  }
                }
              }}
            />
          }
          label={"Eupago setup is complete."}
          sx={{
            '& .MuiFormControlLabel-label.Mui-disabled': {
              color: 'text.primary'
            }
          }}
        />
    );
  }

  return (
    <TextField
      label="Eupago External Key"
      name="eupago_external_key"
      value={externalKey}
      onChange={onChange}
      color="warning"
      size="small"
      fullWidth
    />
  );
};

Eupago.propTypes = {
  externalKey: PropTypes.string,
  chargesEnabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default Eupago;
